<template>
  <div>
    <PageMain
      :loading="loading"
      :tableData="tableData"
      @reload="$refs.header.query()"
      ref="tableMain"
      @radio-change="(e) => $emit('radio-change', e)"
    >
      <page-header ref="header" slot="header" @query="getData" />
    </PageMain>
  </div>
</template>
<script>
import PageMain from './table.vue'
import PageHeader from './header'
export default {
  components: { PageMain, PageHeader },
  props: { selectApi: Function },
  data() {
    return { loading: false, tableData: [] }
  },
  methods: {
    async getData(form = {}) {
      if (!this.selectApi) return
      this.loading = false
      this.tableData = await this.selectApi(form)
      this.loading = false
    },
  },
}
</script>
